/* tslint:disable */
/* eslint-disable */
/**
 * Mclarens.OutlookAddin.Api.WebApi | v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface BillingRole
 */
export interface BillingRole {
    /**
     * 
     * @type {string}
     * @memberof BillingRole
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof BillingRole
     */
    name: string;
}

/**
 * Check if a given object implements the BillingRole interface.
 */
export function instanceOfBillingRole(value: object): value is BillingRole {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('name' in value) || value['name'] === undefined) return false;
    return true;
}

export function BillingRoleFromJSON(json: any): BillingRole {
    return BillingRoleFromJSONTyped(json, false);
}

export function BillingRoleFromJSONTyped(json: any, ignoreDiscriminator: boolean): BillingRole {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'name': json['name'],
    };
}

export function BillingRoleToJSON(value?: BillingRole | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'id': value['id'],
        'name': value['name'],
    };
}

